import {Material} from './types';
import {vec3, vec4} from 'gl-matrix';


export const makeMaterial = (color: vec4, brightness: number, shininess: number): Material => {
    const scaled = color.map((n: number) => n * brightness);
    const scaledV3 = vec3.fromValues(scaled[0], scaled[1], scaled[2]);
    return {
        ambient: vec3.fromValues(brightness / 4, brightness / 4, brightness / 4),
        diffuse: scaledV3,
        specular: vec3.fromValues(1, 1, 1),
        shininess: shininess
    }
}